const baseUrl = "/carbon-savings"

const assureReductionsUrl = `${baseUrl}/assure-reductions`
export const getAssureReductionsUrl = (plantNumber?: string) =>
	plantNumber
		? `${assureReductionsUrl}?plantNumber=${plantNumber}`
		: assureReductionsUrl
export const getAssureReductionDetailsUrl = (
	id: string | number,
	plantNumber: string,
) => `${assureReductionsUrl}/${plantNumber}/${id}`
export const getProductAllocationUrl = () => `${baseUrl}/product-allocation`
export const getPlantOverviewUrl = () => `${baseUrl}/plants`
